import { Fragment, useEffect, useState } from "react"
import { Listbox } from "@headlessui/react"
import { FaTrash } from "react-icons/fa"
import ReviseMeta from "./ReviseMeta"
import SimulateMeta from "./SimulateMeta"
import { api } from "../../../../../../util/APIConfig"
import DropDownIcon from "../../../../../../components/svg/DropDownIcon"

const questionLocation = [
  { id: 1, name: "Revise" },
  { id: 2, name: "Simulate" }
]

const paperType = [
  {
    id: 1,
    name: "PastPaper"
  },
  {
    id: 2,
    name: "MockPaper"
  }
]

export default function Assignments({
  id,
  removeAssignment,
  addAssignmentsData,
  clearAssignmentData
}) {
  const [selectedQuestionLocation, setSelectedQuestionLocation] = useState(0)

  const [admissionTests, setAdmissionTests] = useState({})
  const [selectedAdmissionTest, setSelectedAdmissionTest] = useState(0)

  const [sectionNumbers, setSectionNumbers] = useState({})
  const [selectedSectionNumber, setSelectedSectionNumber] = useState(0)

  const [subjects, setSubjects] = useState({})
  const [selectedSubject, setSelectedSubject] = useState(0)

  const [topics, setTopics] = useState({})
  const [selectedTopic, setSelectedTopic] = useState(0)

  const [examSectionNumber, setExamSectionNumber] = useState([])
  const [selectedExamSectionNumber, setSelectedExamSectionNumber] = useState([])

  const getAdmissionTests = async () =>
    setAdmissionTests(await api("/subject/AdmissionTest"))

  const getSectionNumberByAdmissionTestId = async id =>
    setSectionNumbers(await api(`/subject/SectionNumber/${id}`))

  const getSubjects = async () =>
    setSubjects(await api("/subject/Subject?pageNo=1&pageSize=100000"))

  const getTopicsBySubjectId = async id =>
    setTopics(await api(`/subject/Topic?subjectId=${id}`))

  const getExamSectionNumber = async (id, paperType, year, mockPaperNumber) => {
    const res = await api(
      `/exam/admin/ExamSection/GetExamSectionByFilterLatestAsync?Admissiontestid=${id}&Papertype=${paperType}&${
        paperType === 1 ? `Year=${year}` : `MockPaperNumber=${mockPaperNumber}`
      }`
    )
    setExamSectionNumber(res.data)
  }

  function onBlur(payload) {
    addAssignmentsData(payload, id)
  }

  function clearData(id) {
    clearAssignmentData(id)
    setTopics({})
    setSelectedYear(0)
    setSelectedTopic(0)
    setSectionNumbers({})
    setSelectedSubject(0)
    setSelectedPaperType(0)
    setExamSectionNumber([])
    setSelectedSectionNumber(0)
    setSelectedAdmissionTest(0)
    setSelectedQuestionLocation(0)
    setSelectedExamSectionNumber([])
  }

  const getYears = () => {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = 1; i < 29; i++) {
      years.push(currentYear - i)
    }
    return years
  }

  const years = getYears()

  const [selectedYear, setSelectedYear] = useState(0)

  const [selectedPaperType, setSelectedPaperType] = useState(0)

  useEffect(() => {
    getAdmissionTests()
    getSubjects()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="shadow-4 flex w-full flex-col justify-between rounded-[14px] bg-white p-12">
      <div className="grid grid-cols-4 gap-9">
        <div className="flex flex-col items-start gap-1">
          <div className="flex w-full items-center justify-between px-3">
            <label
              htmlFor="questionStyle"
              className="text-base text-neutral-12"
            >
              Question Location
            </label>
          </div>
          <Listbox
            as="div"
            className="relative w-full"
            value={selectedQuestionLocation}
            onChange={value => {
              clearData(id)
              setSelectedQuestionLocation(value)
            }}
            name="questionLocation"
            id="questionLocation"
            onBlur={() => {
              onBlur({
                questionLocation: selectedQuestionLocation.id
              })
            }}
          >
            {({ open }) => (
              <>
                <Listbox.Button as={Fragment}>
                  <button
                    id="admissionTest"
                    className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                  >
                    <div className="flex w-full items-center justify-between">
                      <span>
                        {selectedQuestionLocation.name
                          ? selectedQuestionLocation.name
                          : "Select Question Location"}
                      </span>
                      <DropDownIcon rotate={`${open ? 180 : 0}`} />
                    </div>
                  </button>
                </Listbox.Button>
                <Listbox.Options
                  as="ul"
                  className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                >
                  {questionLocation.map(location => (
                    <Listbox.Option
                      key={location.id}
                      value={location}
                      className="flex w-full cursor-pointer justify-start"
                    >
                      {location.name}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </>
            )}
          </Listbox>
        </div>

        <ReviseMeta
          selectedQuestionLocation={selectedQuestionLocation}
          selectedAdmissionTest={selectedAdmissionTest}
          setSelectedAdmissionTest={setSelectedAdmissionTest}
          admissionTests={admissionTests}
          selectedSectionNumber={selectedSectionNumber}
          setSelectedSectionNumber={setSelectedSectionNumber}
          getSectionNumberByAdmissionTestId={getSectionNumberByAdmissionTestId}
          getTopicsBySubjectId={getTopicsBySubjectId}
          sectionNumbers={sectionNumbers}
          selectedSubject={selectedSubject}
          setSelectedSubject={setSelectedSubject}
          subjects={subjects}
          selectedTopic={selectedTopic}
          setSelectedTopic={setSelectedTopic}
          topics={topics}
          onBlur={onBlur}
        />

        <SimulateMeta
          selectedQuestionLocation={selectedQuestionLocation}
          selectedAdmissionTest={selectedAdmissionTest}
          setSelectedAdmissionTest={setSelectedAdmissionTest}
          admissionTests={admissionTests}
          years={years}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          paperType={paperType}
          selectedPaperType={selectedPaperType}
          setSelectedPaperType={setSelectedPaperType}
          examSectionNumber={examSectionNumber}
          selectedExamSectionNumber={selectedExamSectionNumber}
          setSelectedExamSectionNumber={setSelectedExamSectionNumber}
          getExamSectionNumber={getExamSectionNumber}
          onBlur={onBlur}
          selectedSubject={selectedSubject}
          setSelectedSubject={setSelectedSubject}
          getTopicsBySubjectId={getTopicsBySubjectId}
          subjects={subjects}
        />
      </div>

      <div className="flex justify-end gap-4 pt-4">
        <div className="group" onClick={() => removeAssignment(id)}>
          <button className="rounded-lg border border-neutral-2 px-3.5 py-3 group-hover:border-danger">
            <FaTrash
              size={20}
              className="text-neutral-2 group-hover:text-danger"
            />
          </button>
        </div>
      </div>
    </div>
  )
}
